// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedContentSidebar-cls1___acce31bbb917db6ffbe","cls2":"SuggestedContentSidebar-cls2__add38750685336fd2ed2 SuggestedContentSidebar-cls1___acce31bbb917db6ffbe"};